import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BreadcrumbDirective } from './breadcrumb.directive';

@NgModule({
  imports: [
    CommonModule
  ],
  exports: [
    BreadcrumbDirective
  ],
  declarations: [
    BreadcrumbDirective
  ]
})
export class BreadcrumbModule {}
